import React from "react";

import { type TooltipConfig, TooltipConfigContextProvider, useTooltipConfig } from "./context";

export interface ConfigProviderProps extends TooltipConfig {
	children: React.ReactNode;
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({
	delayDuration,
	skipDelayDuration,
	disableHoverableContent,
	children,
}) => {
	const parent = useTooltipConfig();

	const value = React.useMemo<TooltipConfig>(
		() => ({
			...parent,
			delayDuration,
			skipDelayDuration,
			disableHoverableContent,
		}),
		[parent, delayDuration, skipDelayDuration, disableHoverableContent],
	);

	return <TooltipConfigContextProvider value={value}>{children}</TooltipConfigContextProvider>;
};

ConfigProvider.displayName = "Tooltip.ConfigProvider";
